var path = '/templates/zenclerk_s/sites/setup/setup_tracking_tag.html';
var html = "<div class=container-fluid><div class=row><div class=\"col-xs-2 col-md-4 setup-illustration with-steps\"><img src=/assets/img/illustration-tracking-xl.png></div><div class=\"col-xs-10 col-md-8 setup-content with-steps\"><div class=\"col-md-10 col-md-offset-1\"><h1>{{ 'sites.setup.setupTrackingTag.torakkingutagu_no_setchi' | translate }}</h1><p>{{ 'sites.setup.setupTrackingTag.ko_no_tagugamausuyasukurooru' | translate }}</p><zcs-tracking-tag-checker project=vm.project show-return=true on-complete=vm.onComplete()></zcs-tracking-tag-checker></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/setup/setup_tracking_tag.html
// module id = 1438
// module chunks = 0